import type { CarouselCollection, CollectionEntity } from 'bundles/collections-carousel/types/CarouselCollection';
import { LEARNING_PRODUCTS } from 'bundles/search-common/constants';
import type { CollectionEntityFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/CollectionEntityFragment';
import getXDPPageLink from 'bundles/unified-description-page-common/utils/getXDPPageLink';

const LEARNING_PRODUCTS_LOOKUP = {
  COURSE: LEARNING_PRODUCTS.Course,
  PROFESSIONAL_CERTIFICATE: LEARNING_PRODUCTS.ProfessionalCertificate,
  PROJECT: LEARNING_PRODUCTS.Project,
  RHYME_PROJECT: LEARNING_PRODUCTS.GuidedProject,
  SPECIALIZATION: LEARNING_PRODUCTS.Specialization,
};

const createEntityWithPartnerLogo = (originalEntity: CollectionEntityFragment): CollectionEntity => {
  return {
    ...originalEntity,
    // @ts-expect-error URL: string
    imageUrl: originalEntity.imageUrl,
    // @ts-expect-error URL: string
    partners: originalEntity.partners.map((partner) => ({
      ...partner,
      logo: partner.squareLogo,
    })),
    // @ts-expect-error URL: string
    partnerLogos: originalEntity.partners && originalEntity.partners.map((partner) => partner.squareLogo),
    productType: LEARNING_PRODUCTS_LOOKUP[originalEntity.productType],
  };
};

export const toCarouselCollection = ({
  recommendationsCollection,
  collectionId,
  subfolderLocaleCode,
}: {
  recommendationsCollection: CollectionEntityFragment[];
  collectionId: string;
  subfolderLocaleCode?: string;
}): CarouselCollection => {
  const updatedEntities = recommendationsCollection.map((collection) => ({
    ...createEntityWithPartnerLogo(collection),
    link: getXDPPageLink({ productPageUrlPath: collection.link, subfolderLocaleCode }),
  }));

  return {
    entities: updatedEntities,
    collectionId,
    title: '',
  } as CarouselCollection;
};
